import React, { Component, Fragment } from 'react';
import { Field } from 'react-final-form';
import { Button, Form } from 'antd';
import Translate from 'react-translate-component';

import { metroCell } from 'constants/dictionaries';
import { formItemLayout, wrapCellFormItem } from 'constants/formItemLayout';
import { METRO_REQUEST_NEW } from 'constants/metro';
import { SelectLoadComponent } from 'components/common/form/Select';
import Input from 'components/common/form/Input';
import ListenerField from 'components/common/form/ListenerField';
import LoadField from 'components/common/fields/LoadField';

export default class CopyFields extends Component {
    render() {
        const { clearPosition, positionCodeForCopy, positionCodeForRestore, oldPositionId, positionCode, departmentCode, disabled, isCNB, isACO } = this.props;

        return (
            <ListenerField listenFieldName={['requestType']}>
                { ({ requestType }) => !departmentCode || !requestType ? null : (
                    requestType === METRO_REQUEST_NEW && (
                        !disabled && !positionCodeForCopy ? (
                            <Form.Item wrapperCol={wrapCellFormItem}>
                                <Field
                                    name='cellId'
                                    component={SelectLoadComponent}
                                    label={{ content: 'metro.request.positionCode' }}
                                    loadName={metroCell}
                                    loadParams={{ DepartmentID: departmentCode }}
                                    placeholder={<Translate content='metro.request.copyPositionPlaceholder' />}
                                    notWrap
                                    nameRender={option => (
                                        <span>
                                            {option.name}
                                            {option.worker_name && (
                                                <span> ({option.worker_name})</span>
                                            )}
                                        </span>
                                    )}
                                    onChange={(...atrs) => {
                                        this.props.getChangeField('positionCode', ['data', 'positionId'])(...atrs);
                                        this.props.getChangeField('positionCodeForCopy', ['data', 'positionId'])(...atrs);
                                    }}
                                />
                            </Form.Item>
                        ) : (
                            disabled ? (
                                positionCodeForCopy ? (
                                    (isCNB || (isACO && !!(positionCodeForRestore || positionCode && !oldPositionId))) && (
                                        <Fragment>
                                            <Form.Item
                                                labelCol={formItemLayout.labelCol}
                                                wrapperCol={formItemLayout.wrapperCol}
                                                label={<Translate content='metro.request.copyPosition' component='span' />}
                                            >
                                                <LoadField
                                                    fieldValue='positionId'
                                                    fieldName='name'
                                                    loadName={metroCell}
                                                    loadParams={{ DepartmentID: departmentCode }}
                                                    fieldId={positionCodeForCopy}
                                                />
                                            </Form.Item>
                                            <Field
                                                name='positionCodeForCopyView'
                                                component={Input}
                                                label={{ content: 'metro.request.positionCopyNumber' }}
                                                disabled
                                            />
                                        </Fragment>
                                    )
                                ) : null
                            ) : (
                                <Fragment>
                                    <Form.Item
                                        labelCol={formItemLayout.labelCol}
                                        wrapperCol={formItemLayout.wrapperCol}
                                        label={<Translate content='metro.request.copyPosition' component='span' />}
                                    >
                                        <LoadField
                                            fieldValue='positionId'
                                            fieldName='name'
                                            loadName={metroCell}
                                            loadParams={{ DepartmentID: departmentCode }}
                                            fieldId={positionCodeForCopy}
                                        />
                                    </Form.Item>
                                    <Form.Item wrapperCol={wrapCellFormItem}>
                                        <Button className="card-button" onClick={clearPosition}>
                                            <Translate content='metro.request.copyOther' />
                                        </Button>
                                    </Form.Item>
                                </Fragment>
                            )
                        )
                    )
                )}
            </ListenerField>
        );
    }
}
